<div [chart]="windChart"></div>
